const customDashboards = {};

export default customDashboards;
